import Vue from 'vue'
// import Bulma from 'bulma'
import Buefy from 'buefy'

// Vue.use(Bulma)
Vue.use(Buefy, {
  defaultIconPack: 'fas',
});